// Datos puros: barra de búsqueda de propiedades (componente compartido).
export const es = {
  propSearch: {
    searchPlaceholder: 'Buscar por ubicación...',
    operation: 'Operación',
    all: 'Todas',
    sale: 'Venta',
    rent: 'Alquiler',
    type: 'Tipo',
    allTypes: 'Todos',
    house: 'Casa',
    apartment: 'Departamento',
    office: 'Oficina',
    land: 'Terreno',
    filters: 'Filtros',
    advancedFilters: 'Filtros Avanzados',
    advancedFiltersDesc: 'Ajusta los filtros para refinar tu búsqueda de propiedades.',
    priceRange: 'Rango de Precio',
    min: 'Mínimo',
    max: 'Máximo',
    bedrooms: 'Dormitorios',
    bathrooms: 'Baños',
    any: 'Cualquiera',
    area: 'Superficie (m²)',
    minArea: 'Mín m²',
    maxArea: 'Máx m²',
    applyFilters: 'Aplicar Filtros',
    clearFilters: 'Limpiar Filtros',
    search: 'Buscar',
    features: 'Características',
    priceRangeError: 'El precio mínimo no puede ser mayor al máximo.',
    areaRangeError: 'La superficie mínima no puede ser mayor a la máxima.',
  },
};
export const en = {
  propSearch: {
    searchPlaceholder: 'Search by location...',
    operation: 'Operation',
    all: 'All',
    sale: 'Sale',
    rent: 'Rent',
    type: 'Type',
    allTypes: 'All',
    house: 'House',
    apartment: 'Apartment',
    office: 'Office',
    land: 'Land',
    filters: 'Filters',
    advancedFilters: 'Advanced Filters',
    advancedFiltersDesc: 'Adjust the filters to refine your property search.',
    priceRange: 'Price Range',
    min: 'Minimum',
    max: 'Maximum',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    any: 'Any',
    area: 'Area (m²)',
    minArea: 'Min m²',
    maxArea: 'Max m²',
    applyFilters: 'Apply Filters',
    clearFilters: 'Clear Filters',
    search: 'Search',
    features: 'Features',
    priceRangeError: 'The minimum price cannot be greater than the maximum.',
    areaRangeError: 'The minimum area cannot be greater than the maximum.',
  },
};
